import React from 'react';
import { useMediaQuery } from 'react-responsive';
import DesktopGrid from "../DashboardBokningV2/GridList/DesktopGrid";
import LargeDesktopGrid from "../DashboardBokningV2/GridList/LargeDesktopGrid";
import ExtraLargeDesktopGrid from "../DashboardBokningV2/GridList/ExtraLargeDesktopGrid";
import XXLargeGrid from "../DashboardBokningV2/GridList/XXLargeGrid";
import TabletGrid from "../DashboardBokningV2/GridList/TabletGrid";
import MobileGrid from "../DashboardBokningV2/GridList/MobileGrid";

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 992, maxWidth: 1199 })
  return isDesktop ? children : null
}
const LargeDesktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1200, maxWidth: 1499 })
  return isDesktop ? children : null
}
const ExtraLargeDesktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1500, maxWidth: 1799 })
  return isDesktop ? children : null
}
const XXLargeDesktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1800 })
  return isDesktop ? children : null
}
const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
  return isTablet ? children : null
}
const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  return isMobile ? children : null
}

const Example = ({Afid, Flags,Kontor}) => (
  <div>
    <XXLargeDesktop><XXLargeGrid Afid={Afid} Flags={Flags} Kontor={Kontor}/></XXLargeDesktop>
    <ExtraLargeDesktop><ExtraLargeDesktopGrid Afid={Afid} Flags={Flags} Kontor={Kontor}/></ExtraLargeDesktop>
    <LargeDesktop><LargeDesktopGrid Afid={Afid} Flags={Flags} Kontor={Kontor}/></LargeDesktop>
    <Desktop><DesktopGrid Afid={Afid} Flags={Flags} Kontor={Kontor}/></Desktop>
    <Tablet><TabletGrid Afid={Afid} Flags={Flags} Kontor={Kontor}/></Tablet>
    <Mobile><MobileGrid Afid={Afid} Flags={Flags} Kontor={Kontor}/></Mobile>
  </div>
)

export default Example;